import React, { useState } from 'react';
import { Box } from '@material-ui/core';
import { registerPhoneNumberStep as registerLocales } from 'globals/locales/registration';
import FsRegisterPhoneNumberForm from 'ui-elements/forms/FsRegisterPhoneNumberForm';
import { FsRegisterPhoneNumberFormDataProps } from 'ui-elements/forms/FsRegisterPhoneNumberForm/FsRegisterPhoneNumberForm';
import {
  FsCounterBox,
  FsHello,
  FsHelloWrapperBox,
  FsCenterBoxLine,
  FsCenterBoxSubTitle,
  FsCenterBoxTitle,
} from 'ui-elements/center-box-elements/FsCenterBoxElements.style-elements';
import { WrapperBox } from './RegisterPhoneNumberStep.style-elements';
import { RegisterStepProps } from '../Steps.types';

interface RegisterInitialStepProps extends RegisterStepProps {
  onGoNext?: (props?: FsRegisterPhoneNumberFormDataProps) => void;
}

const RegisterPhoneNumberStep: React.FC<RegisterInitialStepProps> = ({
  stepIndex,
  stepsLength,
  onGoNext,
}) => {
  const [formDefaults] = useState<FsRegisterPhoneNumberFormDataProps>({
    phoneNumber: '+44',
  });

  return (
    <WrapperBox>
      <FsHelloWrapperBox>
        <FsHello>{registerLocales.hello}</FsHello>
        <FsCounterBox>
          <i>{stepIndex}</i>/{stepsLength}
        </FsCounterBox>
      </FsHelloWrapperBox>
      <FsCenterBoxTitle>{registerLocales.title}</FsCenterBoxTitle>
      <FsCenterBoxSubTitle>{registerLocales.subTitle}</FsCenterBoxSubTitle>
      <FsCenterBoxLine />
      <Box marginTop={3}>
        <FsRegisterPhoneNumberForm {...formDefaults} onGoNext={onGoNext} />
      </Box>
    </WrapperBox>
  );
};

export default RegisterPhoneNumberStep;
